module.exports = __webpack_public_path__ + "files/7cda3ba737b55f0c0d9c581d377ebc61.png";